import React from 'react';
import {
  Container,
  SectionTitle,
  ModosContainer,
  ModoCard,
  ModoIcon,
  ModoTitle,
  ModoDescription,
  ModoFeatures
} from './styled';

const ModosExplicacao = () => {

  return (
    <Container>
      <SectionTitle>
        Entretenimento bíblico do jeito que você nunca viu
      </SectionTitle>

      <ModosContainer>
        {/* Modo Bate-papo — destaque principal */}
        <ModoCard primary>
          <ModoIcon>
            <img src="/images/modo_bate_papo.png" alt="Modo Bate-papo" style={{ width: '100%', height: '100%' }} />
          </ModoIcon>
          <ModoTitle>Modo Bate-papo</ModoTitle>
          <ModoDescription>
            Uma forma diferente e divertida de passar o tempo. Faça perguntas, explore histórias bíblicas, peça uma sugestão — e se surpreenda com o que esses personagens têm a dizer.
          </ModoDescription>

          <ModoFeatures>
            <li>Pergunte sobre fé, sabedoria, histórias da Bíblia e os desafios do dia a dia — e veja cada resposta apoiada em passagens bíblicas</li>
            <li>Cada personagem tem jeito, história e visão de mundo únicos</li>
            <li>Quantas conversas você quiser, na hora que quiser</li>
            <li>Entretenimento bíblico que você não encontra em nenhum outro lugar</li>
          </ModoFeatures>

        </ModoCard>

        {/* Modo Aprender — diferencial bônus */}
        <ModoCard>
          <ModoIcon>
            <img src="/images/modo_aprender.png" alt="Modo Aprender" style={{ width: '100%', height: '100%' }} />
          </ModoIcon>
          <ModoTitle>Modo Praticar ✨ Bônus</ModoTitle>
          <ModoDescription>
            Já estuda inglês, espanhol ou hebraico? Pratique conversas reais com um personagem bíblico — no idioma que você está aprendendo. Ele responde no idioma alvo e corrige em português.
          </ModoDescription>

          <ModoFeatures>
            <li>Pratique inglês, espanhol, francês, alemão, japonês, mandarim e mais</li>
            <li>Hebraico, Grego e Latim — os idiomas originais da Bíblia</li>
            <li>O personagem conversa no idioma alvo e explica em português</li>
            <li>Ideal para estudantes de idiomas, teologia e seminaristas</li>
          </ModoFeatures>

        </ModoCard>
      </ModosContainer>
    </Container>
  );
};

export default ModosExplicacao;
